<template>
  <div id="app">

    <div class="wrapper">
      <div class="wrapper-inner">
        <router-view/>
      </div>
    </div>

    

  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style src="./assets/app.css"></style>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue